import { Invoice } from '../../../models/invoice.model';
import { Pagination } from '../../../models/pagination.model';
import { LiveClass } from '../live-class/models/live-class';

export enum SubscriptionStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING', // payment is pending approval
  SUSPENDED = 'SUSPENDED', // suspened by admin based on payments or other reasons
  CANCELLED = 'CANCELLED', // user canceled the subscription
  EXPIRED = 'EXPIRED', // TODO: check the use case
  COMPLETE = 'COMPLETE',
  RENEWAL_DUE = 'RENEWAL_DUE',
}

export enum LastPaymentStatus {
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}

export enum PaymentType {
  SINGLE = 'SINGLE',
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
  SINGLE_EVENT = 'SINGLE_EVENT',
}

export interface SubscriptionTargetEvent {
  meetingId: string;
  eventDate: Date;
  startTime?: string;
  endTime?: string;
}

export interface Subscription {
  _id: string;
  liveClass: LiveClass;
  user: string;
  nextPaymentDeadline: Date;
  notifyOn: Date;
  nextPaymentAmount: number;
  currency: string;
  createdOn: Date;
  updatedOn: Date;
  expiresOn: Date;
  paymentType: PaymentType;
  targetEvent?: SubscriptionTargetEvent;
  status: SubscriptionStatus;
  invoices?: Invoice[];
  isCancelRequested?: boolean;
}

export interface SubscriptionResponseDTO extends Pagination {
  docs: Subscription[];
}
